// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // endpoint: () => 'https://api.hellius.atmansystems.com',
  // endpoint: () => 'http://3.134.100.236:55300',
  endpoint: () => 'https://hellius.dev.atmansystems.com',
  // endpoint: () => 'http://localhost:3000',

  uri: () => encodeURI(window.location.origin),
  atmanLogo: true,
  softwareName: 'Hellius',
  _AUTHORIZATION_HASH: 'a557eb4c08ee97f6708123af45e8ea37bbcf8c7769eec48de67653bd32ce1391',
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error'; // Included with Angular CLI.
